import React, { useEffect, useState } from "react";
import "./Banner.scss";

function Banner({ top = "0px" }) {
  const [isBannerVisible, setIsBannerVisible] = useState(false);

  const handleClose = () => {
    setIsBannerVisible(false);
    sessionStorage.setItem("isBannerClosed", "true");
  };

  useEffect(() => {
    const isBannerClosed = sessionStorage.getItem("isBannerClosed");
    if (!isBannerClosed) {
      const timer = setTimeout(() => {
        setIsBannerVisible(true);
      }, 250);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div
      className={`banner ${isBannerVisible ? "" : "hidden"}`}
      style={{ top }}
    >
      <div className="banner-content">
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="https://www.wunderkind.co/blog/article/welcome-to-ai-and-analytics-launch/"
          className="banner-register-now"
        >
          Learn about our new AI capabilities and the launch of Wunderkind
          Analytics here.&rarr;{" "}
          {/* <img src="/images/ArrowBanner.svg" alt="Arrow" /> */}
        </a>
        <a className="banner-close-button" onClick={handleClose}>
          X
        </a>
      </div>
    </div>
  );
}

export default Banner;
